import React from 'react';
import About from '../components/About/About';
import './PageStyles.css';

const AboutPage: React.FC = () => {
  return (
    <div className="page-wrapper">
      <About />
    </div>
  );
};

export default AboutPage;
